import { Injectable, Inject } from '@angular/core';
import { SHARED_LIBRARY_CONFIG } from './shared.factory';

@Injectable({
  providedIn: 'root',
})
export class SharedLibraryService {
  constructor(@Inject(SHARED_LIBRARY_CONFIG) private sharedLibraryConfig: any) {
    this.checkIfProductionUrl();
  }

  getSharedLibraryConfig(): any {
    return this.sharedLibraryConfig;
  }

  private checkIfProductionUrl(): void {
    const isProductionUrl = this.sharedLibraryConfig.environmentType === 'production';
  }

  getPetszelBaseDomainByApp(app: '' | 'app' | 'shelter' | 'staff'): string {
    const env = this.getSharedLibraryConfig().environmentType;
    let envPrefix: string;

    switch (env) {
      case 'production':
        envPrefix = '';
        break;
      case 'beta':
        envPrefix = 'beta.';
        break;
      case 'development':
        envPrefix = 'dev.';
        break;
      default:
        envPrefix = 'dev.';
    }

    if (app) {
      return `https://${envPrefix}${app}.petszel.com`;
    } else {
      return `https://${envPrefix}petszel.com`;
    }
  }
}

